import React from 'react';
import { Card } from '../../ui';

const StatsCardSkeleton = () => (
  <Card>
    <Card.Body>
      <div className='flex items-center'>
        <div className='w-12 h-12 bg-gray-200 rounded-lg'></div>
        <div className='ml-4'>
          <div className='h-4 bg-gray-200 rounded w-20 mb-2'></div>
          <div className='h-6 bg-gray-200 rounded w-8'></div>
        </div>
      </div>
    </Card.Body>
  </Card>
);

export default StatsCardSkeleton;
